import React from 'react';
import PropTypes from 'prop-types';
import HeadshotComponent from './headshot';
import moment from 'moment';

const Message = ({ message, user, fromCurrentUser }) => {
  const timestamp   = message.createdAt;
  const messageType = message.isSystemMessage ? 'system' : fromCurrentUser ? 'outgoing' : 'incoming';

  const renderMessageCreator = () => {
    return (
      <div className="message-creator">
        <a className="text-black w3" key={user.id} href={user.profileLink}>{user.displayName}</a>
      </div>
    );
  }

  return (
    <div className={`message-list-row ${messageType}`}>
      <div className="message">
        { message.isSystemMessage && renderMessageCreator() }
        <div className="t5 content w2-5 mb-10"
          dangerouslySetInnerHTML={{ __html: message.body }}>
        </div>

        <p className="t5 message-footer">
          <small className="t5 text-default message-time" title={timestamp}>
            {moment(timestamp).format('h:mma')}
          </small>
        </p>
      </div>
    </div>
  );
};

Message.defaultProps = {
  fromCurrentUser: false
};

Message.propTypes = {
  user: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
  fromCurrentUser: PropTypes.bool
};

export default Message;
